import { FC } from 'react';
import AnalyticsExportChartPage from './AnalyticsExportChartPage';
import AnalyticsExportPostsPage from './AnalyticsExportPostsPage';
import AnalyticsExportSummaryPage from './AnalyticsExportSummaryPage';
import type { AnalyticsExportPage } from './useAnalyticsExportPages';

interface Props {
  page: AnalyticsExportPage;
  pageNumber: number;
  totalPages: number;
}

/** Picks the sheet component for a page model. */
const AnalyticsExportPageRenderer: FC<Props> = ({
  page,
  pageNumber,
  totalPages,
}) => {
  if (page.kind === 'chart') {
    return (
      <AnalyticsExportChartPage
        title={page.title}
        subtitle={page.subtitle}
        chartType={page.chartType}
        stacked={page.stacked}
        data={page.data}
        headlineLabel={page.headlineLabel}
        headlineValue={page.headlineValue}
        profile={page.profile}
        pageNumber={pageNumber}
        totalPages={totalPages}
      />
    );
  }

  if (page.kind === 'posts') {
    return (
      <AnalyticsExportPostsPage
        title={page.title}
        subtitle={page.subtitle}
        posts={page.posts}
        profile={page.profile}
        pageNumber={pageNumber}
        totalPages={totalPages}
      />
    );
  }

  return (
    <AnalyticsExportSummaryPage
      title={page.title}
      subtitle={page.subtitle}
      tiles={page.tiles}
      profile={page.profile}
      pageNumber={pageNumber}
      totalPages={totalPages}
    />
  );
};

export default AnalyticsExportPageRenderer;
